import L from 'leaflet'
import MapIconPointer from '../img/map-icon-pointer-white.png'
import { FlightData, JsonAirport } from '../types'

export class AirportLayer {
  airports: string[] = []
  airportMarkers: L.Marker[] = []
  airportIcon: L.Icon
  layer: L.LayerGroup = new L.LayerGroup<any>()

  constructor (map: L.Map, iconSize: number = 20) {
    this.airportIcon = L.icon({
      iconUrl: MapIconPointer,
      iconSize: [iconSize, iconSize],
      iconAnchor: [iconSize / 2, iconSize],
      className: 'fvlib-airport-dot'
    })

    this.layer.addTo(map)
  }

  createAirportMarkers (flights: FlightData[], labelType: 'code' | 'name' = 'code') {
    for (const flight of flights) {
      if (flight.departureAirport.code && flight.departureAirport.coords) {
        this.addAirportMarker(flight.departureAirport.coords, flight.departureAirport[labelType])
      }
      if (flight.arrivalAirport.code) {
        // anti meridian
        if (flight.arrivalAirport.coords && flight.departureAirport.coords) {
          flight.arrivalAirport.coords.lng += flight.arrivalAirport.coords.lng - flight.departureAirport.coords.lng > 180 ? -360 : flight.departureAirport.coords.lng - flight.arrivalAirport.coords.lng > 180 ? 360 : 0
        }
        this.addAirportMarker(flight.arrivalAirport.coords, flight.arrivalAirport[labelType])
      }
    }
  }

  addAirportMarker (airport: JsonAirport, label: string) {
    if (!airport || this.airports.includes(airport.code)) return
    const marker = L.marker(new L.LatLng(airport.lat, airport.lng), {
      icon: this.airportIcon,
      title: airport.code
    }).addTo(this.layer).bindTooltip(label, {
      className: 'leaflet-airport-tooltip fvlib-airport-tooltip',
      pane: 'city-names',
      permanent: true,
      direction: 'bottom'
    })
    this.airportMarkers.push(marker)
    this.airports.push(airport.code)
  }
}
